module.exports = "/assets/images/cheeky.png";